var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CPUTensor } from '../../tensor/cpu/tensor';
import { OnnxNode } from '../node';
export class TileNode extends OnnxNode {
    constructor(attributes, inputs, outputs, constants, onnxVersion, mode) {
        super(attributes, inputs, outputs, constants, onnxVersion, mode);
    }
    forward(inputs) {
        return __awaiter(this, void 0, void 0, function* () {
            const x = inputs[0];
            const repeats = inputs[1];
            if (!(repeats instanceof CPUTensor)) {
                throw new Error('Tile only works with CPU tensor as repeats');
            }
            if (this.onnxVersion < 13 && this.onnxVersion >= 6) {
                const _repeats = new Array(repeats.size);
                for (let i = 0; i < repeats.size; i++) {
                    _repeats[i] = repeats.get(i);
                }
                return [x.repeat(_repeats)];
            }
            throw new Error(`Tile with onnx version ${this.onnxVersion} not yet implemented`);
        });
    }
    getType() {
        return 'Tile';
    }
    delete() { }
}
//# sourceMappingURL=tile.js.map